import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { isPayLaterFlowPath, clearPayLaterSession } from "../utils/conferencePayLaterSession";

/**
 * Clears the conference pay-later session when the user navigates outside
 * Registration Success and Payment pages (e.g. to event details or conference list).
 * Renders nothing; mount once inside BrowserRouter.
 */
export default function ConferencePayLaterSessionGuard() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!isPayLaterFlowPath(pathname)) {
      clearPayLaterSession();
    }
  }, [pathname]);

  return null;
}
